import { render, staticRenderFns } from "./NewsMessageContentDialog.vue?vue&type=template&id=58277e97&scoped=true"
import script from "./NewsMessageContentDialog.vue?vue&type=script&lang=js"
export * from "./NewsMessageContentDialog.vue?vue&type=script&lang=js"
import style0 from "./NewsMessageContentDialog.vue?vue&type=style&index=0&id=58277e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58277e97",
  null
  
)

export default component.exports